import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { expertises } from '../../data/expertises';
export function Expertises() {
  return <section aria-labelledby="expertises-title" className="py-20 lg:py-28" data-id="element-74" data-mp="294vss4ad9bjg">
      <div className="mx-auto grid max-w-site gap-12 px-6 lg:grid-cols-12 lg:px-10" data-id="element-75" data-mp="296ytpjd24p2y">
        <div className="lg:col-span-4" data-id="element-76" data-mp="2485dhj6dyjz3">
          <div className="lg:sticky lg:top-32" data-id="element-77" data-mp="1z7hof31pwd7i">
            <h2 id="expertises-title" className="font-serif text-4xl leading-tight tracking-tight text-ink lg:text-5xl" data-id="element-78" data-mp="1z897xfi1ikhf">
              Nos expertises
            </h2>
            <p className="mt-6 max-w-sm text-[17px] leading-relaxed text-muted" data-id="element-79" data-mp="1qfphh2bwjm7o">
              Une approche intégrée qui relie stratégie, programmation et mise en œuvre, à toutes les échelles
              du territoire.
            </p>
            <Link to="/expertises" className="mt-8 inline-flex items-center gap-2 border-b border-ink pb-1 text-[15px] text-ink transition-colors duration-150 hover:border-accent hover:text-accent" data-id="element-80" data-mp="1gfoy5ge1963h">
              Toutes nos expertises
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="xfhzyjol011t" />
            </Link>
          </div>
        </div>

        <ul className="border-t border-ink lg:col-span-8" data-id="element-82" data-mp="irn3qtbd7ejz">
          {expertises.map(expertise => <li key={expertise.title} className="border-b border-line" data-id="element-83" data-mp="nmssdzw5j7br">
              <Link to="/expertises" className="group grid gap-4 py-8 transition-colors duration-150 md:grid-cols-[1fr_auto] md:gap-10" data-id="element-84" data-mp="1bfsp9ia8t7kv">
                <div data-id="element-85" data-mp="11fa1icfk56xo">
                  <h3 className="font-serif text-2xl leading-snug text-ink transition-colors duration-150 group-hover:text-accent" data-id="element-86" data-mp="11fs8a2zuj3ju">
                    {expertise.title}
                  </h3>
                  <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-muted" data-id="element-87" data-mp="3m4zeejwpainq">{expertise.summary}</p>
                  <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2" aria-label="Missions types" data-id="element-88" data-mp="3r6x49wzlwbpn">
                    {expertise.missions.map(mission => <li key={mission} className="text-sm text-ink-soft" data-id="element-89" data-mp="1snjynqj7f9ci">
                        {mission}
                      </li>)}
                  </ul>
                </div>
                <ArrowUpRightIcon className="hidden h-5 w-5 text-muted transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-accent md:block" aria-hidden="true" data-id="element-90" data-mp="1iys9fq5j335a" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}